enum DonationActionType {
  Honor = 'Honor',
  Memory = 'Memory',
  Support = 'Support',
}
export default DonationActionType;
